module.exports = __webpack_public_path__ + "static/media/question-circle-solid.d681ff95.svg";